import { render, staticRenderFns } from "./VideosPanel.vue?vue&type=template&id=1434cc90&scoped=true&"
import script from "./VideosPanel.vue?vue&type=script&lang=js&"
export * from "./VideosPanel.vue?vue&type=script&lang=js&"
import style0 from "./VideosPanel.vue?vue&type=style&index=0&id=1434cc90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1434cc90",
  null
  
)

/* custom blocks */
import block0 from "./VideosPanel.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports